import { Row, Col, Image, Space, Typography } from "antd";
import { SoundOutlined } from "@ant-design/icons";
import lightningIcon from "~/public/static/icons/lightning@2x.png";
import priceIcon from "~/public/static/icons/price@2x.png";
import GroupKind from "~/components/groups/GroupKind";
import GroupMemberCount from "~/components/groups/GroupMemberCount";

const { Title } = Typography;

const GroupMark = ({ group }: any) => (
  <>
    {group.featured && (
      <div className="group-type">
        <img src={lightningIcon.src} alt="精选" />
        <span>精选</span>
      </div>
    )}
    {group.paid && (
      <div className="group-type group-type-pay">
        <img src={priceIcon.src} alt="付费" />
        <span>付费</span>
      </div>
    )}
    {group.recent && (
      <div className="group-type group-type-new">
        <SoundOutlined />
        <span className="ml-5">新群</span>
      </div>
    )}
  </>
);


const GroupInfoSmall = ({ group, className }: any) => {
  const hasMark = group.featured || group.paid || group.recent;
  
  return (
    <div className={`group-sm-wrapper ${className}`}>
      <Row align="middle" wrap={false}>
        <Col flex="80px" style={{ textAlign: "left" }}>
          <Image src={group.logo.url} preview={false} alt={group.name} width={70} height={70} style={{ borderRadius: "8px" }} />
        </Col>
        <Col flex="auto">
          <Space direction="vertical" size={7} style={{ display: "flex" }}>
            <Row wrap={false}>
              <Col flex="auto">
                <Title level={5} style={{ marginBottom: 0 }} title={group.name} ellipsis>{group.name}</Title>
              </Col>
              {hasMark && (
                <Col flex="60px">
                  <GroupMark group={group} />
                </Col>
              )}
            </Row>
            <Row gutter={10}>
              <Col><GroupKind group={group} /></Col>
              <Col><GroupMemberCount group={group} /></Col>
            </Row>
          </Space>
        </Col>
      </Row>
    </div>
  );
};
export default GroupInfoSmall;
